export const API_URL = 'https://api.quantumaxis.com.br/widgets/v1/'

export const API_SUBSCRIPTION_KEY = '79e477b0dace44c1bb0b54e06fc8103b'

export const HOME_TITLE = ''

export const THEME = ''

